/**
 * Раскладка страницы /video-retouch: вкладки рейки и высота кадра.
 *
 * ПОЧЕМУ ОТДЕЛЬНЫМ ФАЙЛОМ. Здесь нет ни одной строки про ретушь — только про
 * то, сколько места чему достаётся. video-tool.js владеет алгоритмом и
 * состоянием ролика; смешивать с ним геометрию значит чинить одно и ломать
 * другое.
 *
 * ДВЕ ЗАДАЧИ
 * ──────────
 * 1. ВКЛАДКИ. Восемь ползунков делятся на кожу, глаза-зубы и свет. Раньше
 *    четыре из них лежали под `<details>`: половина тула была невидима, а
 *    раскрытие толкало рейку вниз на две сотни пикселей. Вкладки показывают
 *    все три группы и не двигают высоту — панели выровнены по самой длинной.
 *
 * 2. ВЫСОТА КАДРА ПО ОСТАТКУ. Кадр раньше брал долю ОКНА (52vh), которая
 *    ничего не знает о плёнке плеера, ряде режимов и карточке выдачи под ним.
 *    Замер: окно 800 px → кадр 416, весь прибор 900, и главная кнопка уезжала
 *    за нижний край. Здесь высота считается как остаток: окно минус обвязка
 *    (её можно только измерить) минус карточка выдачи минус запас под шапку.
 *
 * ⚠️ Пересчёт обязан идти и на `resize`, и на смене вкладки, и когда карточка
 * выдачи меняет высоту (появилась полоса хода, вылез блок лимита) — иначе
 * бюджет посчитан по прошлой раскладке. Поэтому вдобавок к событиям стоит
 * ResizeObserver на карточке выдачи — и ТОЛЬКО на ней: см. предупреждение
 * у chromeHeight про обратную связь.
 */
(function () {
    'use strict';

    var root = document.querySelector('.vr-app');
    if (!root) return;

    /* ── 1. Вкладки ─────────────────────────────────────────────────────── */

    var tabs = document.getElementById('vrTabs');
    var hint = document.getElementById('vrHint');
    var panes = [].slice.call(document.querySelectorAll('.vr-pane'));

    function showTab(key) {
        if (!tabs) return;
        [].forEach.call(tabs.querySelectorAll('[data-tab]'), function (b) {
            var on = b.getAttribute('data-tab') === key;
            b.classList.toggle('on', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panes.forEach(function (p) {
            var on = p.id === 'vrPane' + key.charAt(0).toUpperCase() + key.slice(1);
            // `hidden`, а не display в стиле: атрибут переживает смену темы и
            // виден скринридеру как «этой панели сейчас нет».
            p.hidden = !on;
            if (on && hint) hint.textContent = p.getAttribute('data-hint') || '';
        });
        fit();
    }

    if (tabs) {
        tabs.addEventListener('click', function (e) {
            var b = e.target.closest('[data-tab]');
            if (b) showTab(b.getAttribute('data-tab'));
        });
        // Стрелками — как в любом tablist: вкладки объявлены role="tab", и без
        // клавиатуры это объявление было бы обещанием, которого нет.
        tabs.addEventListener('keydown', function (e) {
            if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            var list = [].slice.call(tabs.querySelectorAll('[data-tab]'));
            var i = list.indexOf(document.activeElement);
            if (i < 0) return;
            e.preventDefault();
            var n = list[(i + (e.key === 'ArrowRight' ? 1 : list.length - 1)) % list.length];
            n.focus();
            showTab(n.getAttribute('data-tab'));
        });
    }

    /* Панели одной высоты: переключение не двигает ни рейку, ни соседнюю
       сцену. Меряем максимум ОДИН раз, когда все панели уже разложены. */
    function lockPaneHeight() {
        var box = document.querySelector('.vr-panes');
        if (!box || !panes.length) return;
        box.style.minHeight = '';
        var max = 0;
        panes.forEach(function (p) {
            var was = p.hidden;
            p.hidden = false;
            max = Math.max(max, p.offsetHeight);
            p.hidden = was;
        });
        if (max > 0) box.style.minHeight = max + 'px';
    }

    /* ── 2. Бюджет высоты кадра ─────────────────────────────────────────── */

    /**
     * Запас сверху: сколько окна съедает то, что ЛИПНЕТ к его верху.
     *
     * ⚠️ Считать по первому попавшемуся `header` нельзя. Замер 06.09.2026: на
     * десктопе шапка сайта НЕ липкая (в верху окна стоит промо-полоса, которая
     * уезжает при прокрутке), а элемент, попадавший под селектор `.header`,
     * имеет нулевую высоту — резерв выходил 28 px там, где нужен ноль, и 28 же
     * там, где на телефоне липнет полноценная шапка. Поэтому берём только
     * элементы, у которых `position` реально sticky или fixed И которые стоят
     * у верхней кромки: остальное при прокрутке уходит и место не занимает.
     */
    function headerReserve() {
        var top = 0;
        var nodes = document.querySelectorAll('header, .site-header, [class*="header"], [class*="topbar"]');
        for (var i = 0; i < nodes.length; i++) {
            var e = nodes[i], cs = getComputedStyle(e);
            if ((cs.position === 'sticky' || cs.position === 'fixed')
                && e.offsetHeight > 0 && e.getBoundingClientRect().top < 120) {
                top = Math.max(top, e.offsetHeight);
            }
        }
        return Math.min(top, 120) + 24;   // 24 — воздух, чтобы прибор не лип к кромке
    }

    var MIN_FRAME = 240;   // ниже этого кадр перестаёт быть прибором
    var MAX_FRAME = 620;   // выше — пустая трата места на широком экране

    function h(el) { return el ? el.offsetHeight : 0; }
    // Отступ считается только у ВИДИМОГО элемента: у скрытой строки вердикта
    // offsetHeight уже 0, а marginTop по-прежнему 10 — и бюджет терял бы
    // десять пикселей на пустом месте.
    function mt(el) { return (el && el.offsetHeight) ? (parseFloat(getComputedStyle(el).marginTop) || 0) : 0; }

    /**
     * Обвязка кадра — СУММА того, что стоит рядом, а не разность
     * «высота карточки минус кадр».
     *
     * ⚠️⚠️ Через разность считать НЕЛЬЗЯ, и это не стиль. Разность зависит от
     * высоты карточки, которую сама же правка и меняет: `fit()` пишет
     * переменную → кадр меняет высоту → карточка меняет высоту → наблюдатель
     * зовёт `fit()` снова. Замер: страница уходила в бесконечный цикл, главный
     * поток был занят целиком, и разбор сцены не заканчивался ВООБЩЕ — кнопка
     * «Сохранить видео» не открывалась ни через 30, ни через 75 секунд.
     * Симптом выглядел как «сломался алгоритм», а сломана была геометрия.
     * Слагаемые ниже от высоты кадра не зависят, поэтому петли нет.
     */
    function chromeHeight(stage) {
        var cs = getComputedStyle(stage);
        var pad = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0);
        var pbar = root.querySelector('.vr-pbar');
        var tools = root.querySelector('.vr-tools');
        var truth = root.querySelector('.vr-truth');
        var sum = pad + h(pbar) + mt(pbar) + h(truth) + mt(truth);
        // В боковом макете ряд режимов стоит СПРАВА от кадра, а не под ним, и
        // в вертикальную обвязку не входит.
        if (!stage.classList.contains('tall')) sum += h(tools) + mt(tools);
        return sum;
    }

    /**
     * Ровнять низ колонок — только когда они и так почти вровень.
     *
     * Замер 06.09.2026: на горизонтальном ролике рейка и сцена расходятся на
     * единицы пикселей, и выравнивание убирает рваный край. На вертикальном
     * сцена выше на ~310 px (кадр 9:16 занимает всю доступную высоту), и та же
     * растяжка превращает разницу в пустое поле внутри карточки настроек —
     * пустота в рамке читается хуже, чем две карточки разной длины.
     * Порог 140 px: примерно две строки настроек, ниже этого край выглядит
     * сбоем вёрстки, выше — намеренно разными блоками.
     */
    var EVEN_MAX_GAP = 140;

    function evenOut() {
        var grid = document.getElementById('vrWork');
        var rail = root.querySelector('.tc-rail > .tc-panel');
        var stage = root.querySelector('.vr-stagepanel');
        if (!grid || !rail || !stage) return;
        // Меряем БЕЗ растяжки, иначе меряли бы собственный результат.
        grid.classList.remove('vr-even');
        if (Math.abs(rail.offsetHeight - stage.offsetHeight) <= EVEN_MAX_GAP) {
            grid.classList.add('vr-even');
        }
    }

    var lastPx = 0;

    function fit() {
        var stage = root.querySelector('.vr-stagepanel');
        var full = root.querySelector('.tc-full');
        if (!stage) return;

        var avail = window.innerHeight - headerReserve() - chromeHeight(stage) - (full ? h(full) + 14 : 0);
        var px = Math.max(MIN_FRAME, Math.min(MAX_FRAME, Math.round(avail)));
        // Писать только на настоящее изменение: лишняя запись переменной — это
        // лишний пересчёт стилей у всей ветки, а на пиксель дрожания он никому
        // не нужен.
        if (Math.abs(px - lastPx) >= 4) {
            lastPx = px;
            root.style.setProperty('--vr-frame-max', px + 'px');
        }
        evenOut();
    }

    /* ── запуск и пересчёт ──────────────────────────────────────────────── */

    var raf = 0;
    function schedule() {
        if (raf) return;
        raf = requestAnimationFrame(function () { raf = 0; fit(); });
    }

    window.addEventListener('resize', schedule);
    window.addEventListener('orientationchange', schedule);

    // Карточки меняют высоту без resize окна: появилась полоса хода, приехал
    // блок лимита, вердикт стал двухстрочным. Без наблюдателя бюджет остаётся
    // посчитанным по прошлой раскладке — то есть неверным ровно тогда, когда
    // раскладка и поменялась.
    if (typeof ResizeObserver === 'function') {
        // ⛔ Наблюдать за .vr-stagepanel НЕЛЬЗЯ: её высоту меняет сам fit(),
        // и наблюдатель замкнул бы петлю (см. комментарий у chromeHeight).
        // Карточка выдачи от высоты кадра не зависит — за ней смотреть можно.
        var ro = new ResizeObserver(schedule);
        var full = root.querySelector('.tc-full');
        if (full) ro.observe(full);
    }

    function boot() {
        lockPaneHeight();
        fit();
        // Кадр появляется не сразу: до выбора файла коробка нулевая. Досчитаем,
        // когда рабочая область раскроется.
        var work = document.getElementById('vrWork');
        if (work && typeof MutationObserver === 'function') {
            new MutationObserver(function () { schedule(); })
                .observe(work, { attributes: true, attributeFilter: ['hidden'] });
        }
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
})();
